import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback, useState } from '@redneckz/uni-jsx/lib/hooks';
import { useBool } from '@redneckz/uni-jsx/lib/hooks/useBool';
import { style } from '../../utils/style.js';
import { Icon } from '../Icon/Icon.js';
import { Input } from '../Input/Input.js';
import { renderLabel } from '../Input/renderLabel.js';
import { formatOption } from './formatOption.js';
import { useSelectPopup } from './useSelectPopup.js';
export const Select = JSX(
// eslint-disable-next-line complexity
({ className, label, options = [], value, valid = true, isBorder = true, placeholder = '', isSearch = false, iconVersion = 'black', onChange, disabled, }) => {
    const [isOpen, { setFalse: close, setTrue: open }] = useBool();
    const [query, setQuery] = useState('');
    const isDisabled = disabled || options.length === 0;
    const hasOpen = isOpen && !isDisabled;
    const handleClose = useCallback(() => {
        setQuery('');
        close();
    }, []);
    const inputRef = useSelectPopup({
        isOpen,
        options,
        value,
        query,
        onChange,
        onClose: handleClose,
        iconVersion,
    });
    return (_jsxs("div", { className: style('space-y-xs', className), children: [renderLabel(label), _jsxs("div", { className: style('relative', hasOpen ? 'z-20' : 'z-10'), ref: inputRef, children: [_jsxs("div", { className: style('h-14 [&>*]:p-m pr-6 text-l flex items-center justify-between text-primary-text relative z-10 overflow-hidden', getStyle(isBorder, valid, isDisabled)), onClick: hasOpen ? handleClose : open, children: [_jsx("p", { className: "line-clamp-2 text-ellipsis", children: formatOption(value) || placeholder }), renderIcon(hasOpen, iconVersion)] }), isSearch && hasOpen ? (_jsx("div", { className: style('absolute top-0 w-full z-20'), children: _jsx(Input, { type: "text", autoFocus: true, value: query, onChange: setQuery }) })) : null] })] }));
});
const renderIcon = (isOpen, iconVersion) => (_jsx(Icon, { className: style('absolute right-0 flex self-center', { 'rotate-180': !isOpen }), iconVersion: iconVersion, name: "ArrowUpIcon", width: "16", height: "16" }));
const getStyle = (isBorder, valid, disabled) => style(isBorder ? 'border rounded-md ' : '', isBorder && !disabled ? 'hover:border-primary-hover' : '', disabled ? 'bg-main-divider' : 'cursor-pointer ', valid ? 'border-gray' : 'border-error');
//# sourceMappingURL=Select.js.map